/* eslint-disable indent */

<template>
  <div class="loading-wrap" v-if="isLoading">
    <md-progress-spinner
      :md-diameter="100"
      :md-stroke="10"
      class="md-accent"
      md-mode="indeterminate"
    ></md-progress-spinner>
    <!-- {{refCount}} -->
  </div>
</template>

<script>
import AuthService from "../authService.js";
import { getDBToken, setDBToken } from "../helpers/index-db.js";

export default {
  name: "LoginPage",
  props: {
    msg: String,
  },
  data: function() {
    return {
      l_code: "lana",
      l_lastname: "zzz",
      auth: new AuthService(),
      signedIn: null,
      isLoading: false,
    };
  },
  methods: {
    login: function(code, lastname) {
      // console.log(" AuthService", this.auth);
      // this.auth.getUser();
      // console.log("this.auth.getUser();" ,this.auth.getUser())
      // this.$store.dispatch("login", { code: code, lastname: lastname });
      // this.$router.push("/content/landing");
    },

    async goToLanding() {
      await this.$store.dispatch("getPaymentMethods");
      this.$router.push("/content/landing").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },

    async loginAuth() {
      this.isLoading = true;
      const token = this.$route.params.token;
      const user = await this.auth.checkIfUser();

      //*TOKEN (DO THE LOGIN)
      if (!!token) {
        console.log("*** token to login ***");
        if (!!user) {
          console.log("*** token and user ***");
          if (token !== user.profile?.sub || user.expired) {
            console.log("*** other user or expired (signOutFirst) ***", {
              expired: user.expired,
              sameToken: token === user.profile?.sub,
              token,
              userToken: user.profile?.sub,
            });
            localStorage.clear();
            await this.auth.signOutFirst(token, user?.id_token);
          } else {
            console.log("*** same user not expired ***");
            localStorage.setItem("token", `${user.profile?.sub}`);
            await this.goToLanding();
          }
        } else {
          console.log("*** token and no user not (login with token) ***");
          localStorage.clear();
          await this.auth.startSigninClient(token);
        }
      }
      //* NO TOKEN (IF USER, GO TO LANDING, OTHERWISE GO TO LOGIN)
      else {
        console.log("*** no token to login ***");
        // const signIn = await this.auth.getUser();
        if (user && !user.expired) {
          console.log("*** has user not expired (go to landing) ***");
          localStorage.setItem("token", `${user.profile?.sub}`);
          await this.goToLanding();
        } else {
          console.log("*** no user (signIn) ***");
          localStorage.clear();
          await this.auth.signIn();
        }
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.loginAuth()
      .then()
      .catch((error) => console.error(error));
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.form .form__btn {
  color: #fff !important;
}
.btn-pink {
  min-width: 100% !important;
}
</style>
